import { useState, useEffect } from "react";
import { buscarParceirosService } from "../../../services/buscarParceirosService";
import { Parceiro } from "../../../interfaces/Parceiro";

export const useBuscarParceiros = () => {
  const [parceiros, setParceiros] = useState<Parceiro[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscar = async () => {
    setIsLoading(true);
    const data = await buscarParceirosService();

    setParceiros(data);
    setIsLoading(false);
  };

  useEffect(() => {
    buscar();
  }, []);

  return { parceiros, isLoading, buscar };
};
